<template>
  <span>
    {{ value }}
  </span>
</template>

<script>
export default {
  name: 'TextValue',
  props: ['value']
}
</script>
